import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

import "./deleteSectionModal.css";

const DeleteSectionModal = ({ show, onHide, section, onConfirm }) => {
  if (!section) return null;

  const hasSubsections = section.subsections && section.subsections.length > 0;

  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Delete Section?"
      confirmLabel="Delete"
      confirmVariant="danger"
      className="delete-section-modal"
    >
      <div>
        {hasSubsections ? (
          <ul className="list-unstyled mb-0">
            <li className="mb-2">• This section contains subsections.</li>
            <li>• Deleting it will also remove all its subsections.</li>
          </ul>
        ) : (
          <p className="mb-0">
            Are you sure you want to delete the section "{section.name}"?
          </p>
        )}
      </div>
    </ConfirmationModal>
  );
};

export default DeleteSectionModal;
